const prefixCls = 'web.menu.';

export const localesMenu = {
  [prefixCls + 'dashboard']: {
    zh_CN: '我的主页',
    en_GB: 'Dashboard',
  },
  [prefixCls + 'listing']: {
    zh_CN: '亚马逊上架',
    en_GB: 'Listing',
  },
  [prefixCls + 'collect']: {
    zh_CN: '链接上架',
    en_GB: 'Collect',
  },
  [prefixCls + 'follow']: {
    zh_CN: 'Catalog',
    en_GB: 'Catalog',
  },
  [prefixCls + 'fbp-duration']: {
    zh_CN: 'FBP时长修改',
    en_GB: 'FBP Duration',
  },
  [prefixCls + 'advert']: {
    zh_CN: '广告列表',
    en_GB: 'Advert',
  },
  [prefixCls + 'advert-plus']: {
    zh_CN: '广告管理+',
    en_GB: 'Advert+',
  },
  [prefixCls + 'sales']: {
    zh_CN: '销量统计',
    en_GB: 'Sales',
  },
  [prefixCls + 'cate']: {
    zh_CN: '选品助手',
    en_GB: 'Cate',
  },
  [prefixCls + 'user.cate']: {
    zh_CN: '选品助手',
    en_GB: 'Cate',
  },
  [prefixCls + 'bestSell']: {
    zh_CN: 'Best Sell',
    en_GB: 'Best Sell',
  },
  [prefixCls + 'alibaba']: {
    zh_CN: '1688上架',
    en_GB: 'Alibaba',
  },
  [prefixCls + 'procure']: {
    zh_CN: '采购管理',
    en_GB: 'Procure',
  },
  [prefixCls + 'invoice']: {
    zh_CN: '发货管理',
    en_GB: 'Invoice',
  },
  [prefixCls + 'invoice-plus']: {
    zh_CN: '发货管理+',
    en_GB: 'Invoice+',
  },
  [prefixCls + 'subAccount']: {
    zh_CN: '子账号管理',
    en_GB: 'Sub Account',
  },
  [prefixCls + 'admin']: {
    zh_CN: '系统管理',
    en_GB: 'Admin',
  },
  [prefixCls + 'account']: {
    zh_CN: '账号管理',
    en_GB: 'Account Management',
  },
  [prefixCls + 'menus']: {
    zh_CN: '权限管理',
    en_GB: 'Permission Management',
  },
  [prefixCls + 'customer-feature']: {
    zh_CN: '功能开关',
    en_GB: 'Feature Toggle',
  },
  [prefixCls + 'shop']: {
    zh_CN: '店铺授权',
    en_GB: 'Shop Authorization',
  },
  [prefixCls + 'store-authorization']: {
    zh_CN: '店铺授权',
    en_GB: 'Store Authorization',
  },
  [prefixCls + 'dsOrder']: {
    zh_CN: 'DS订单',
    en_GB: 'DS Order',
  },
  类目管理: {
    zh_CN: '类目管理',
    en_GB: 'Category Management',
  },
  类目销售列表: {
    zh_CN: '类目销售列表',
    en_GB: 'Category Sales List',
  },
  [prefixCls + 'warehouse']: {
    zh_CN: '仓库管理',
    en_GB: 'Warehouse',
  },
  [prefixCls + 'buyer.list']: {
    zh_CN: '买家列表',
    en_GB: 'Buyer List',
  },
  [prefixCls + 'noon_order.list']: {
    zh_CN: '测评列表',
    en_GB: 'NOON Order',
  },
  [prefixCls + 'admin.noon_order.list']: {
    zh_CN: '测评列表',
    en_GB: 'NOON Order',
  },
  [prefixCls + 'asn']: {
    zh_CN: '自动约仓',
    en_GB: 'ASN Booking',
  },
  [prefixCls + 'asn-grabber']: {
    zh_CN: '抢仓插件',
    en_GB: 'ASN Grabber',
  },
  [prefixCls + 'extension']: {
    zh_CN: '浏览器插件',
    en_GB: 'Browser Extension',
  },
  [prefixCls + 'replenish-plan']: {
    zh_CN: '补货计划',
    en_GB: 'Replenish Plan',
  },
  [prefixCls + 'sku-keyword']: {
    zh_CN: 'SKU关键词',
    en_GB: 'SKU Keywords',
  },
  [prefixCls + 'deal']: {
    zh_CN: '活动管理',
    en_GB: 'Deals',
  },
  [prefixCls + 'finance']: {
    zh_CN: '财务报表',
    en_GB: 'Finance',
  },
};
